function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Descriptions, Divider, Alert, Tag, Upload, DatePicker, Select } from 'antd';
import { Row, Col, Container } from "react-bootstrap";
import Common from "../includes/Common";
import { Upload as UploadIcon } from 'react-bootstrap-icons';
import moment from "moment";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
dayjs.extend(customParseFormat);
var SaveVaccinData = function SaveVaccinData(_ref) {
  var candidat = _ref.candidat,
    handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    file = _useState6[0],
    setFile = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    if (candidat.vaccin_process != null) formData.append("vaccin_process_id", candidat.vaccin_process.id.toString());
    formData.append("user_id", Common.currentUser.id);
    formData.append("customer_id", candidat.id);
    formData.append("attached_file", file);
    formData.append("unit_penta", values.unit_penta);
    formData.append("first_dose_penta", values.first_dose_penta);
    formData.append("recall_first_penta", values.recall_first_penta);
    formData.append("recall_second_penta", values.recall_second_penta);
    formData.append("comment_penta", values.comment_penta);
    formData.append("unit_coq", values.unit_coq);
    formData.append("first_dose_coq", values.first_dose_coq);
    formData.append("recall_first_coq", values.recall_first_coq);
    formData.append("recall_second_coq", values.recall_second_coq);
    formData.append("comment_coq", values.comment_coq);
    formData.append("unit_teta", values.unit_teta);
    formData.append("first_dose_teta", values.first_dose_teta);
    formData.append("recall_first_teta", values.recall_first_teta);
    formData.append("recall_second_teta", values.recall_second_teta);
    formData.append("comment_teta", values.comment_teta);
    formData.append("unit_diph", values.unit_diph);
    formData.append("first_dose_diph", values.first_dose_diph);
    formData.append("recall_first_diph", values.recall_first_diph);
    formData.append("recall_second_diph", values.recall_second_diph);
    formData.append("comment_diph", values.comment_diph);
    formData.append("unit_influ", values.unit_influ);
    formData.append("first_dose_influ", values.first_dose_influ);
    formData.append("recall_first_influ", values.recall_first_influ);
    formData.append("recall_second_influ", values.recall_second_influ);
    formData.append("comment_influ", values.comment_influ);
    formData.append("unit_typhoid", values.unit_typhoid);
    formData.append("first_dose_typhoid", values.first_dose_typhoid);
    formData.append("recall_first_typhoid", values.recall_first_typhoid);
    formData.append("recall_second_typhoid", values.recall_second_typhoid);
    formData.append("comment_typhoid", values.comment_typhoid);
    formData.append("unit_meningite", values.unit_meningite);
    formData.append("first_dose_meningite", values.first_dose_meningite);
    formData.append("recall_first_meningite", values.recall_first_meningite);
    formData.append("recall_second_meningite", values.recall_second_meningite);
    formData.append("comment_meningite", values.comment_meningite);
    formData.append("unit_yf", values.unit_yf);
    formData.append("first_dose_yf", values.first_dose_yf);
    formData.append("recall_first_yf", values.recall_first_yf);
    formData.append("recall_second_yf", values.recall_second_yf);
    formData.append("comment_yf", values.comment_yf);
    formData.append("unit_bvac", values.unit_bvac);
    formData.append("first_dose_bvac", values.first_dose_bvac);
    formData.append("recall_first_bvac", values.recall_first_bvac);
    formData.append("recall_second_bvac", values.recall_second_bvac);
    formData.append("comment_bvac", values.comment_bvac);
    axios.post(Common.baseApiUrl + "setvaccindata", formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    if (candidat && candidat.vaccin_process != null) {
      form.setFieldsValue({
        unit_penta: candidat.vaccin_process.unit_penta,
        first_dose_penta: candidat.vaccin_process.first_dose_penta != null && candidat.vaccin_process.first_dose_penta != 'undefined' ? dayjs(candidat.vaccin_process.first_dose_penta, 'YYYY-MM-DD') : null,
        recall_first_penta: candidat.vaccin_process.recall_first_penta != null && candidat.vaccin_process.recall_first_penta != 'undefined' ? dayjs(candidat.vaccin_process.recall_first_penta, 'YYYY-MM-DD') : null,
        //: dayjs().add(1, 'M') ,
        recall_second_penta: candidat.vaccin_process.recall_second_penta != null && candidat.vaccin_process.recall_second_penta != 'undefined' ? dayjs(candidat.vaccin_process.recall_second_penta, 'YYYY-MM-DD') : null,
        //: dayjs().add(7, 'M') ,
        comment_penta: candidat.vaccin_process.comment_penta,
        unit_coq: candidat.vaccin_process.unit_coq,
        first_dose_coq: candidat.vaccin_process.first_dose_coq != null && candidat.vaccin_process.first_dose_coq != 'undefined' ? dayjs(candidat.vaccin_process.first_dose_coq, 'YYYY-MM-DD') : null,
        recall_first_coq: candidat.vaccin_process.recall_first_coq != null && candidat.vaccin_process.recall_first_coq != 'undefined' ? dayjs(candidat.vaccin_process.recall_first_coq, 'YYYY-MM-DD') : null,
        //: dayjs().add(1, 'M') ,
        recall_second_coq: candidat.vaccin_process.recall_second_coq != null && candidat.vaccin_process.recall_second_coq != 'undefined' ? dayjs(candidat.vaccin_process.recall_second_coq, 'YYYY-MM-DD') : null,
        //: dayjs().add(7, 'M') ,
        comment_coq: candidat.vaccin_process.comment_coq,
        unit_teta: candidat.vaccin_process.unit_teta,
        first_dose_teta: candidat.vaccin_process.first_dose_teta != null && candidat.vaccin_process.first_dose_teta != 'undefined' ? dayjs(candidat.vaccin_process.first_dose_teta, 'YYYY-MM-DD') : null,
        recall_first_teta: candidat.vaccin_process.recall_first_teta != null && candidat.vaccin_process.recall_first_teta != 'undefined' ? dayjs(candidat.vaccin_process.recall_first_teta, 'YYYY-MM-DD') : null,
        //: dayjs().add(1, 'M') ,
        recall_second_teta: candidat.vaccin_process.recall_second_teta != null && candidat.vaccin_process.recall_second_teta != 'undefined' ? dayjs(candidat.vaccin_process.recall_second_teta, 'YYYY-MM-DD') : null,
        //: dayjs().add(7, 'M') ,
        comment_teta: candidat.vaccin_process.comment_teta,
        unit_diph: candidat.vaccin_process.unit_diph,
        first_dose_diph: candidat.vaccin_process.first_dose_diph != null && candidat.vaccin_process.first_dose_diph != 'undefined' ? dayjs(candidat.vaccin_process.first_dose_diph, 'YYYY-MM-DD') : null,
        recall_first_diph: candidat.vaccin_process.recall_first_diph != null && candidat.vaccin_process.recall_first_diph != 'undefined' ? dayjs(candidat.vaccin_process.recall_first_diph, 'YYYY-MM-DD') : null,
        //: dayjs().add(1, 'M') ,
        recall_second_diph: candidat.vaccin_process.recall_second_diph != null && candidat.vaccin_process.recall_second_diph != 'undefined' ? dayjs(candidat.vaccin_process.recall_second_diph, 'YYYY-MM-DD') : null,
        //: dayjs().add(7, 'M') ,
        comment_diph: candidat.vaccin_process.comment_diph,
        unit_influ: candidat.vaccin_process.unit_influ,
        first_dose_influ: candidat.vaccin_process.first_dose_influ != null && candidat.vaccin_process.first_dose_influ != 'undefined' ? dayjs(candidat.vaccin_process.first_dose_influ, 'YYYY-MM-DD') : null,
        recall_first_influ: candidat.vaccin_process.recall_first_influ != null && candidat.vaccin_process.recall_first_influ != 'undefined' ? dayjs(candidat.vaccin_process.recall_first_influ, 'YYYY-MM-DD') : null,
        //: dayjs().add(1, 'M') ,
        recall_second_influ: candidat.vaccin_process.recall_second_influ != null && candidat.vaccin_process.recall_second_influ != 'undefined' ? dayjs(candidat.vaccin_process.recall_second_influ, 'YYYY-MM-DD') : null,
        //: dayjs().add(7, 'M') , 
        comment_influ: candidat.vaccin_process.comment_influ,
        unit_typhoid: candidat.vaccin_process.unit_typhoid,
        first_dose_typhoid: candidat.vaccin_process.first_dose_typhoid != null && candidat.vaccin_process.first_dose_typhoid != 'undefined' ? dayjs(candidat.vaccin_process.first_dose_typhoid, 'YYYY-MM-DD') : null,
        recall_first_typhoid: candidat.vaccin_process.recall_first_typhoid != null && candidat.vaccin_process.recall_first_typhoid != 'undefined' ? dayjs(candidat.vaccin_process.recall_first_typhoid, 'YYYY-MM-DD') : null,
        //: dayjs().add(1, 'M') ,
        recall_second_typhoid: candidat.vaccin_process.recall_second_typhoid != null && candidat.vaccin_process.recall_second_typhoid != 'undefined' ? dayjs(candidat.vaccin_process.recall_second_typhoid, 'YYYY-MM-DD') : null,
        //: dayjs().add(7, 'M') ,
        comment_typhoid: candidat.vaccin_process.comment_typhoid,
        unit_meningite: candidat.vaccin_process.unit_meningite,
        first_dose_meningite: candidat.vaccin_process.first_dose_meningite != null && candidat.vaccin_process.first_dose_meningite != 'undefined' ? dayjs(candidat.vaccin_process.first_dose_meningite) : null,
        recall_first_meningite: candidat.vaccin_process.recall_first_meningite != null && candidat.vaccin_process.recall_first_meningite != 'undefined' ? dayjs(candidat.vaccin_process.recall_first_meningite, 'YYYY-MM-DD') : null,
        //: dayjs().add(1, 'M') ,
        recall_second_meningite: candidat.vaccin_process.recall_second_meningite != null && candidat.vaccin_process.recall_second_meningite != 'undefined' ? dayjs(candidat.vaccin_process.recall_second_meningite, 'YYYY-MM-DD') : null,
        //: dayjs().add(7, 'M') ,
        comment_meningite: candidat.vaccin_process.comment_meningite,
        unit_yf: candidat.vaccin_process.unit_yf,
        first_dose_yf: candidat.vaccin_process.first_dose_yf != null && candidat.vaccin_process.first_dose_yf != 'undefined' ? dayjs(candidat.vaccin_process.first_dose_yf) : null,
        recall_first_yf: candidat.vaccin_process.recall_first_yf != null && candidat.vaccin_process.recall_first_yf != 'undefined' ? dayjs(candidat.vaccin_process.recall_first_yf) : null,
        //: dayjs().add(1, 'M') ,
        recall_second_yf: candidat.vaccin_process.recall_second_yf != null && candidat.vaccin_process.recall_second_yf != 'undefined' ? dayjs(candidat.vaccin_process.recall_second_yf) : null,
        //: dayjs().add(7, 'M') ,
        comment_yf: candidat.vaccin_process.comment_yf,
        unit_bvac: candidat.vaccin_process.unit_bvac,
        first_dose_bvac: candidat.vaccin_process.first_dose_bvac != null && candidat.vaccin_process.first_dose_bvac != 'undefined' ? dayjs(candidat.vaccin_process.first_dose_bvac, 'YYYY-MM-DD') : null,
        recall_first_bvac: candidat.vaccin_process.recall_first_bvac != null && candidat.vaccin_process.recall_first_bvac != 'undefined' ? dayjs(candidat.vaccin_process.recall_first_bvac, 'YYYY-MM-DD') : null,
        //: dayjs().add(1, 'M') ,
        recall_second_bvac: candidat.vaccin_process.recall_second_bvac != null && candidat.vaccin_process.recall_second_bvac != 'undefined' ? dayjs(candidat.vaccin_process.recall_second_bvac, 'YYYY-MM-DD') : null,
        //: dayjs().add(7, 'M') , 
        comment_bvac: candidat.vaccin_process.comment_bvac
      });
    } else {
      form.setFieldsValue({
        unit_penta: "0,5",
        /*first_dose_penta: dayjs(new Date(), 'YYYY-MM-DD') ,  
        recall_first_penta: dayjs().add(1, 'M') , 
        recall_second_penta: dayjs().add(7, 'M') ,  */
        comment_penta: "",
        unit_coq: "0,5",
        /*first_dose_coq: dayjs() ,
        recall_first_coq: dayjs().add(1, 'M') ,
        recall_second_coq: dayjs().add(7, 'M') ,*/
        comment_coq: "",
        unit_teta: "0,5",
        /*first_dose_teta: dayjs() ,
        recall_first_teta: dayjs().add(1, 'M') ,
        recall_second_teta: dayjs().add(7, 'M') ,*/
        comment_teta: "",
        unit_diph: "0,5",
        /*first_dose_diph: dayjs() ,
        recall_first_diph: dayjs().add(1, 'M') , 
        recall_second_diph: dayjs().add(7, 'M') ,*/
        comment_diph: "",
        unit_influ: "0,5",
        /*first_dose_influ: dayjs() ,
        recall_first_influ: dayjs().add(1, 'M') ,
        recall_second_influ: dayjs().add(7, 'M') ,*/
        comment_influ: "",
        unit_typhoid: "0,5",
        /*first_dose_typhoid: dayjs() ,
        recall_first_typhoid: dayjs().add(1, 'M') ,
        recall_second_typhoid: dayjs().add(7, 'M') ,*/
        comment_typhoid: "",
        unit_meningite: "0,5",
        /*first_dose_meningite: dayjs() ,
        recall_first_meningite: dayjs().add(1, 'M') ,
        recall_second_meningite: dayjs().add(7, 'M') , */
        comment_meningite: "",
        unit_yf: "0,5",
        //first_dose_yf: dayjs() ,
        comment_yf: "",
        unit_bvac: "1",
        /*first_dose_bvac: dayjs() , 
        recall_first_bvac: dayjs().add(1, 'M') ,
        recall_second_bvac: dayjs().add(7, 'M') , */
        comment_bvac: ""
      });
    }
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        padding: "20px",
        background: "#B7693F",
        borderRadius: "0px 7px 7px 7px",
        color: "#FFFFFF"
      },
      children: ["Sauvegarder les donn\xE9es de vaccination pour le candidat ", /*#__PURE__*/_jsx("b", {
        children: candidat.name
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })
      }), /*#__PURE__*/_jsxs("fieldset", {
        style: {
          background: "#EEF5F1",
          padding: "5px 25px",
          borderRadius: "8px"
        },
        children: [/*#__PURE__*/_jsx("legend", {
          style: {
            fontWeight: "bolder",
            color: "#E82E44",
            fontSize: "18px"
          },
          children: "E PENTA"
        }), /*#__PURE__*/_jsxs("fieldset", {
          children: [/*#__PURE__*/_jsx("legend", {
            children: "HEPATITE B"
          }), /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "unit_penta",
                label: "Unit\xE9",
                rules: [{
                  required: true,
                  message: 'Champs obligatoire'
                }],
                children: /*#__PURE__*/_jsx(Input, {
                  addonAfter: "Ulml"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "first_dose_penta",
                label: "1\xE8re Dose",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  format: "DD/MM/YYYY"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "recall_first_penta",
                label: "Rappel 1",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  format: "DD/MM/YYYY"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "recall_second_penta",
                label: "Rappel 2",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  format: "DD/MM/YYYY"
                })
              })
            })]
          }), /*#__PURE__*/_jsx(Form.Item, {
            name: "comment_penta",
            label: "Observation",
            children: /*#__PURE__*/_jsx(Input.TextArea, {
              autoSize: {
                minRows: 2,
                maxRows: 12
              }
            })
          })]
        }), /*#__PURE__*/_jsxs("fieldset", {
          children: [/*#__PURE__*/_jsx("legend", {
            children: "COQUELLUCHE"
          }), /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "unit_coq",
                label: "Unit\xE9",
                rules: [{
                  required: true,
                  message: 'Champs obligatoire'
                }],
                children: /*#__PURE__*/_jsx(Input, {
                  addonAfter: "Ulml"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "first_dose_coq",
                label: "1\xE8re Dose",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  format: "DD/MM/YYYY"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "recall_first_coq",
                label: "Rappel 1",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  format: "DD/MM/YYYY"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "recall_second_coq",
                label: "Rappel 2",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  format: "DD/MM/YYYY"
                })
              })
            })]
          }), /*#__PURE__*/_jsx(Form.Item, {
            name: "comment_coq",
            label: "Observation",
            children: /*#__PURE__*/_jsx(Input.TextArea, {
              autoSize: {
                minRows: 2,
                maxRows: 12
              }
            })
          })]
        }), /*#__PURE__*/_jsxs("fieldset", {
          children: [/*#__PURE__*/_jsx("legend", {
            children: "TETANOS"
          }), /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "unit_teta",
                label: "Unit\xE9",
                rules: [{
                  required: true,
                  message: 'Champs obligatoire'
                }],
                children: /*#__PURE__*/_jsx(Input, {
                  addonAfter: "Ulml"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "first_dose_teta",
                label: "1\xE8re Dose",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  format: "DD/MM/YYYY"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "recall_first_teta",
                label: "Rappel 1",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  format: "DD/MM/YYYY"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "recall_second_teta",
                label: "Rappel 2",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  format: "DD/MM/YYYY"
                })
              })
            })]
          }), /*#__PURE__*/_jsx(Form.Item, {
            name: "comment_teta",
            label: "Observation",
            children: /*#__PURE__*/_jsx(Input.TextArea, {
              autoSize: {
                minRows: 2,
                maxRows: 12
              }
            })
          })]
        }), /*#__PURE__*/_jsxs("fieldset", {
          children: [/*#__PURE__*/_jsx("legend", {
            children: "DIPHTHERIE"
          }), /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "unit_diph",
                label: "Unit\xE9",
                rules: [{
                  required: true,
                  message: 'Champs obligatoire'
                }],
                children: /*#__PURE__*/_jsx(Input, {
                  addonAfter: "Ulml"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "first_dose_diph",
                label: "1\xE8re Dose",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  format: "DD/MM/YYYY"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "recall_first_diph",
                label: "Rappel 1",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  format: "DD/MM/YYYY"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "recall_second_diph",
                label: "Rappel 2",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  format: "DD/MM/YYYY"
                })
              })
            })]
          }), /*#__PURE__*/_jsx(Form.Item, {
            name: "comment_diph",
            label: "Observation",
            children: /*#__PURE__*/_jsx(Input.TextArea, {
              autoSize: {
                minRows: 2,
                maxRows: 12
              }
            })
          })]
        }), /*#__PURE__*/_jsxs("fieldset", {
          children: [/*#__PURE__*/_jsx("legend", {
            children: "HAEMOPHILUS INFLUENZAE"
          }), /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "unit_influ",
                label: "Unit\xE9",
                rules: [{
                  required: true,
                  message: 'Champs obligatoire'
                }],
                children: /*#__PURE__*/_jsx(Input, {
                  addonAfter: "Ulml"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "first_dose_influ",
                label: "1\xE8re Dose",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  format: "DD/MM/YYYY"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "recall_first_influ",
                label: "Rappel 1",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  format: "DD/MM/YYYY"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "recall_second_influ",
                label: "Rappel 2",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  format: "DD/MM/YYYY"
                })
              })
            })]
          }), /*#__PURE__*/_jsx(Form.Item, {
            name: "comment_influ",
            label: "Observation",
            children: /*#__PURE__*/_jsx(Input.TextArea, {
              autoSize: {
                minRows: 2,
                maxRows: 12
              }
            })
          })]
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("fieldset", {
        style: {
          background: "#F5F3EE",
          padding: "10px 25px"
        },
        children: [/*#__PURE__*/_jsx("legend", {
          style: {
            fontWeight: "bolder",
            color: "#E82E44",
            fontSize: "18px"
          },
          children: "F. TYPHOIDE"
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "unit_typhoid",
              label: "Unit\xE9",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Input, {
                addonAfter: "Ulml"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "first_dose_typhoid",
              label: "1\xE8re Dose",
              children: /*#__PURE__*/_jsx(DatePicker, {
                format: "DD/MM/YYYY"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "recall_first_typhoid",
              label: "Rappel 1",
              children: /*#__PURE__*/_jsx(DatePicker, {
                format: "DD/MM/YYYY"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "recall_second_typhoid",
              label: "Rappel 2",
              children: /*#__PURE__*/_jsx(DatePicker, {
                format: "DD/MM/YYYY"
              })
            })
          })]
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: "comment_typhoid",
          label: "Observation",
          children: /*#__PURE__*/_jsx(Input.TextArea, {
            autoSize: {
              minRows: 2,
              maxRows: 12
            }
          })
        })]
      }), /*#__PURE__*/_jsxs("fieldset", {
        style: {
          background: "#EEEFF5",
          padding: "10px 25px"
        },
        children: [/*#__PURE__*/_jsx("legend", {
          style: {
            fontWeight: "bolder",
            color: "#E82E44",
            fontSize: "18px"
          },
          children: "MENINGITE"
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "unit_meningite",
              label: "Unit\xE9",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Input, {
                addonAfter: "Ulml"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "first_dose_meningite",
              label: "1\xE8re Dose",
              children: /*#__PURE__*/_jsx(DatePicker, {
                format: "DD/MM/YYYY"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "recall_first_meningite",
              label: "Rappel 1",
              children: /*#__PURE__*/_jsx(DatePicker, {
                format: "DD/MM/YYYY"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "recall_second_meningite",
              label: "Rappel 2",
              children: /*#__PURE__*/_jsx(DatePicker, {
                format: "DD/MM/YYYY"
              })
            })
          })]
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: "comment_meningite",
          label: "Observation",
          children: /*#__PURE__*/_jsx(Input.TextArea, {
            autoSize: {
              minRows: 2,
              maxRows: 12
            }
          })
        })]
      }), /*#__PURE__*/_jsxs("fieldset", {
        style: {
          background: "#F5F2F2",
          padding: "10px 25px"
        },
        children: [/*#__PURE__*/_jsx("legend", {
          style: {
            fontWeight: "bolder",
            color: "#E82E44",
            fontSize: "18px"
          },
          children: "F. JAUNE"
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "unit_yf",
              label: "Unit\xE9",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Input, {
                addonAfter: "Ulml"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "first_dose_yf",
              label: "1\xE8re Dose",
              children: /*#__PURE__*/_jsx(DatePicker, {
                format: "DD/MM/YYYY"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "recall_first_yf",
              label: "Rappel 1",
              children: /*#__PURE__*/_jsx(DatePicker, {
                format: "DD/MM/YYYY"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "recall_second_yf",
              label: "Rappel 2",
              children: /*#__PURE__*/_jsx(DatePicker, {
                format: "DD/MM/YYYY"
              })
            })
          })]
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: "comment_yf",
          label: "Observation",
          children: /*#__PURE__*/_jsx(Input.TextArea, {
            autoSize: {
              minRows: 2,
              maxRows: 12
            }
          })
        })]
      }), /*#__PURE__*/_jsxs("fieldset", {
        style: {
          background: "#F5EFE4",
          padding: "10px 25px"
        },
        children: [/*#__PURE__*/_jsx("legend", {
          style: {
            fontWeight: "bolder",
            color: "#E82E44",
            fontSize: "18px"
          },
          children: "B Vac"
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "unit_bvac",
              label: "Unit\xE9",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Input, {
                addonAfter: "Ulml"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "first_dose_bvac",
              label: "1\xE8re Dose",
              children: /*#__PURE__*/_jsx(DatePicker, {
                format: "DD/MM/YYYY"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "recall_first_bvac",
              label: "Rappel 1",
              children: /*#__PURE__*/_jsx(DatePicker, {
                format: "DD/MM/YYYY"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "recall_second_bvac",
              label: "Rappel 2",
              children: /*#__PURE__*/_jsx(DatePicker, {
                format: "DD/MM/YYYY"
              })
            })
          })]
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: "comment_bvac",
          label: "Observation",
          children: /*#__PURE__*/_jsx(Input.TextArea, {
            autoSize: {
              minRows: 2,
              maxRows: 12
            }
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "VALIDER"
          })
        })
      })]
    })]
  });
};
export default SaveVaccinData;